import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["state", "checked"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from 'react';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { C as CheckboxCheckedContext } from '../__utils-fdd6f8a4.js';
import { jsx } from 'react/jsx-runtime';
var checkmark = /*#__PURE__*/jsx("svg", {
  display: "block",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5pt",
  viewBox: "0 0 16 16",
  height: "1em",
  width: "1em",
  children: /*#__PURE__*/jsx("polyline", {
    points: "4,8 7,12 12,4"
  })
});

function getChildren(props) {
  if (props.checked) {
    return props.children || checkmark;
  }

  if (typeof props.children === "function") {
    return props.children;
  }

  return null;
}
/**
 * A component hook that returns props that can be passed to `Role` or any other
 * Ariakit component to render a check mark icon.
 * @see https://ariakit.org/components/checkbox
 * @example
 * ```jsx
 * const props = useCheckboxCheck({ checked: true });
 * <Role {...props} />
 * ```
 */


var useCheckboxCheck = createHook(function (_ref) {
  var _checked;

  var state = _ref.state,
      checked = _ref.checked,
      props = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(CheckboxCheckedContext);
  checked = (_checked = checked) != null ? _checked : context;
  var children = getChildren({
    checked: checked,
    children: props.children
  });
  props = _objectSpread(_objectSpread({
    "aria-hidden": true
  }, props), {}, {
    children: children,
    style: _objectSpread({
      width: "1em",
      height: "1em",
      pointerEvents: "none"
    }, props.style)
  });
  return props;
});
/**
 * A component that renders a a check mark icon.
 * @see https://ariakit.org/components/checkbox
 * @example
 * ```jsx
 * <CheckboxCheck checked />
 * ```
 */

var CheckboxCheck = createComponent(function (props) {
  var htmlProps = useCheckboxCheck(props);
  return createElement("span", htmlProps);
});
export { CheckboxCheck, useCheckboxCheck };